import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { router } from "./routes";
import { RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store/store";
import TokenRefresher from "./components/TokenRefresher";

//rutas de la app

const root = ReactDOM.createRoot(document.getElementById("wrapper"));
root.render(
  //<React.StrictMode>
  <>
    <Provider store={store}>
      <TokenRefresher/>
         <RouterProvider router={router} />
    </Provider>
  </>
  //</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
